import { createFileRoute, notFound } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { getCategoryContent } from "@/tools/unit-converter/lib/category-content";
import { getCategory } from "@/tools/unit-converter/lib/units";
import { CategoryPage } from "@/tools/unit-converter/pages/CategoryPage";

export const Route = createFileRoute("/unit-converter/$category")({
  ssr: true,
  loader: ({ params }) => {
    if (!getCategory(params.category)) throw notFound();
  },
  head: ({ params }) => {
    const cat = getCategory(params.category);
    if (!cat) return {};
    const name = cat.name();
    const path = `/unit-converter/${cat.id}`;
    const content = getCategoryContent(cat.id);
    return {
      meta: [
        { title: m.uc_cat_meta_title({ category: name }) },
        {
          name: "description",
          content: m.uc_cat_meta_description({ category: name }),
        },
        {
          property: "og:title",
          content: m.uc_cat_meta_title({ category: name }),
        },
        {
          property: "og:description",
          content: m.uc_cat_meta_description({ category: name }),
        },
        ...i18nOgMeta(path),
      ],
      links: [...i18nLinks(path)],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: m.uc_breadcrumb_home(),
                item: localeUrl(`/`),
              },
              {
                "@type": "ListItem",
                position: 2,
                name: m.uc_tool_name(),
                item: localeUrl(`/unit-converter`),
              },
              {
                "@type": "ListItem",
                position: 3,
                name,
                item: localeUrl(`${path}`),
              },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: (content?.faqs ?? []).map((faq) => ({
              "@type": "Question",
              name: faq.q(),
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.a(),
              },
            })),
          }),
        },
      ],
    };
  },
  component: CategoryRoute,
});

function CategoryRoute() {
  const { category } = Route.useParams();
  const cat = getCategory(category);
  if (!cat) return null;
  return <CategoryPage category={cat} />;
}
